<template>
    <v-container class="pa-0 ma-0" id="mainhomecontainer">
        <v-card class="overview" elevation="0">
            <v-card-title class="pa-0">
                <v-container style="min-height:200px;" class="topbg">
                <v-row>
                    <v-col
                    cols="12"
                    md="12"
                    color="white--text"
                    class="text-center mt-5 mb-5"
                    style="color:#fff;"
                    >
                    Welcome to Juzzap
                    <br />
                    <span class style="font-size:16px;">A NEW PARADIGM</span>
                    </v-col>
                </v-row>
                </v-container>

                <v-row class="pwa-content">
                <v-col cols="12" md="12" class="text-center">
                    <img :src="juzzapLogo" width="100" />
                </v-col>
                </v-row>


            </v-card-title>

            <v-card-text>

                <v-row>
                    <v-col cols="12">
                        <h2>Default Menu Option</h2>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">



                        <v-radio-group v-model="row" column >
                            <v-radio label="Pdf Menu" value="pdf"></v-radio>
                            <v-radio label="Menu Link" value="menu"></v-radio>
                            <v-radio label="Digital Menu" value="digital" ></v-radio>

                        </v-radio-group>
                    </v-col>
                </v-row>

                <v-card v-if="row=='pdf'">
                    <v-card-title>
                        <v-row>
                            <v-col cols="12">
                                PDF Menu Section
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-form id="frmpdf" v-model="valid" enctype="multipart/form-data">

                            <v-row>
                                <v-col cols="12">

                                    <v-file-input name="pdfmenu" label="PDF File Upload" accept="application/pdf"></v-file-input>

                                    <!--<v-btn color="primary" @click="$refs.file.click()">
                                         <input
                                        type="file"
                                        ref="file"
                                        @change="uploadPdf($event)"
                                        accept="pdf/*"
                                        class="d-none"
                                        id="pdffile"
                                        /> Upload PDF File
                                    </v-btn>-->


                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" class="text-center" >
                                    <!-- <v-btn color="primary" @click="savepdf" max-width="100%">Save</v-btn> -->
                                    <v-btn @click="savepdffile">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>

                <v-card class="mt-5" v-if="row=='menu'">
                    <v-card-title>
                        <v-row>
                            <v-col cols="12">
                                Menu Link Section
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-form id="frmmenulink" v-model="valid" enctype="multipart/form-data">

                            <v-row>
                                <v-col cols="12">

                                    <v-text-field

                                        v-model="menulink"
                                        label="Menu Link"
                                        name="menulink"
                                        type="text"
                                        v-validate="'required|menulink'"
                                        :error-messages="errors.collect('menulink')"
                                        data-vv-name="menulink"
                                        required>
                                    </v-text-field>




                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" class="text-center" >
                                    <v-btn color="primary" @click.prevent="savemenulink" max-width="100%">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>

            </v-card-text>

        </v-card>
    </v-container>
</template>
<script>
import Vue from "vue";

export default {
     props: {
    source: String
  },
  data: () =>
  ({
      valid:true,
      pdfmenu:1,
      row:null,
      row: 'pdf',
      menulink:'',
      juzzapLogo: require("@/assets/logo-Copy.png"),
      storeBusiness:[],
  }),
  created() {
    this.storeBusiness = JSON.parse(localStorage.getItem("business"));

  },
  watch()
  {
      if(this.row=='digital')
      {
          console.log('mounted');
          this.$router.push({
            name: "businessfoodlist",
            params: { id: this.storeBusiness.id }
            });
      }
  },
  methods:
  {
      savepdffile()
      {
          if (this.$validator.validateAll())
          {
            let fd = new FormData(document.getElementById('frmpdf'));

            fd.append('defaultpdfmenu','1');
            this.$http.post('https://api.juzzap.com/api/pdfmenu/'+this.storeBusiness.id,fd)
            .then(res=>{

            })
            .catch(err=>{
            console.log(err.response);
            });
          }
      },
      digitalmenu()
      {
            if(this.row=='digital')
            {
                this.$router.push({
                name: "businessfoodlist",
                params: { id: this.storeBusiness.id }
                });
            }
      }
  }
}
</script>
<style scoped>
.topbg {
  background: #fe5800;
}
.pwa-content {
  margin-top: -63px !important;
}
.txt-color
{

    color: #7697A1;
}
</style>
